import { ExternalTournament } from '@img-arena/consoles-api-streaming'
import { DetailedCell } from '@/components/table/base/TableBase/components/DetailedCell'
import { formatDate } from '@/utils/dateFormat/dateFormat'
import splitIntoWords from '@/utils/splitIntoWords/splitIntoWords'

import { Column, COLUMN_CELL_TYPE, Filter } from '../table/base'
import { FilterType } from '../table/base/FilterableTable/FilterableTable.types'

export const MAPPED_TOURNAMENTS_COLUMNS: Column<ExternalTournament>[] = [
  {
    id: '$name',
    label: 'Name',
    type: COLUMN_CELL_TYPE.COMPONENT,
    render: (value) => <DetailedCell value={value.name} subValue={value.externalProperty.name} />,
    comparator: (a, b) => a.name.localeCompare(b.name),
    sx: { width: 600 },
    sortAttribute: '$name'
  },
  {
    id: 'startDate',
    label: 'Start Time',
    type: COLUMN_CELL_TYPE.COMPONENT,
    render: (value) => {
      const { time, fullDate } = formatDate(value)

      return <DetailedCell value={time} subValue={fullDate} />
    },
    comparator: (a, b) => Number(new Date(a)) - Number(new Date(b))
  },
  {
    id: 'endDate',
    label: 'End Time',
    type: COLUMN_CELL_TYPE.COMPONENT,
    render: (value) => {
      const { time, fullDate } = formatDate(value)

      return <DetailedCell value={time} subValue={fullDate} />
    },
    comparator: (a, b) => Number(new Date(a)) - Number(new Date(b))
  }
]

const getOptions = (data: ExternalTournament[]) => {
  const sportMap = new Map<string, FilterType>()
  const propertyMap = new Map<string, FilterType>()

  data.forEach((item, index) => {
    const { sportType, externalProperty } = item

    const formattedSport = sportType.split(' ').join('')

    if (!sportMap.has(formattedSport)) {
      sportMap.set(formattedSport, { value: index.toString(), label: splitIntoWords(sportType) })
    }

    if (!propertyMap.has(externalProperty.name)) {
      propertyMap.set(externalProperty.name, {
        value: index.toString(),
        label: externalProperty.name
      })
    }
  })

  return {
    sportOptions: Array.from(sportMap.values()),
    propertyOptions: Array.from(propertyMap.values())
  }
}

export const getMappedTournamentsFilters = (
  data: ExternalTournament[]
): Filter<ExternalTournament>[] => {
  const { sportOptions, propertyOptions } = getOptions(data)

  return [
    {
      type: 'freeTextSearch',
      paramName: 'name',
      placeholder: 'Search',
      filterOptions: (item, value) => {
        return item.name.toLowerCase().includes(value.toLowerCase())
      },
      width: 200
    },
    {
      paramName: 'sportType',
      type: 'select',
      label: 'Sport',
      options: sportOptions.sort((a, b) => {
        if (!a || !b || !a.label || !b.label) {
          return 0
        }
        return a.label?.localeCompare(b.label)
      }),
      filterOptions: (item, [filter]) => {
        const { sportType } = item

        return sportType === filter.label
      }
    },
    {
      paramName: 'externalProperty.name',
      type: 'autocomplete',
      label: 'Property',
      options: propertyOptions.sort((a, b) => {
        if (!a || !b || !a.label || !b.label) {
          return 0
        }
        return a.label?.localeCompare(b.label)
      }),
      filterOptions: (item, [filter]) => {
        const { externalProperty } = item

        return externalProperty.name === filter.label
      },
      width: 200,
      listBoxWidth: 500
    }
  ]
}
